import React from "react";

import { OptionsType, ResponseType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { AdvancedListRequest } from "types/api/commons";
import { SpecialOfferBody, SpecialOfferDetails, SpecialOfferListItem } from "types/api/specialOffer";

function useSpecialOfferApi() {
    const { get, del, post, put } = useHttpManaged();

    const getAllSpecialOffer = React.useCallback(
        (queryParams: AdvancedListRequest, options?: OptionsType): ResponseType<ListResponse<SpecialOfferListItem>> => {
            return get<undefined, AdvancedListRequest, ListResponse<SpecialOfferListItem>>({
                url: "/special-offer",
                queryParams: queryParams,
                options: options,
            });
        },
        [get],
    );

    const getOneSpecialOffer = React.useCallback(
        (pathParams: PathParamsWithId, options?: OptionsType): ResponseType<SpecialOfferDetails> => {
            return get<PathParamsWithId, undefined, SpecialOfferDetails>({
                url: "/special-offer/:id",
                pathParams: pathParams,
                options: options,
            });
        },
        [get],
    );

    const createSpecialOffer = React.useCallback(
        (body: SpecialOfferBody, options?: OptionsType): ResponseType<ResponseWithId> => {
            return post<undefined, undefined, SpecialOfferBody, ResponseWithId>({
                url: "/special-offer",
                body: body,
                options: options,
            });
        },
        [post],
    );

    const updateSpecialOffer = React.useCallback(
        (pathParams: PathParamsWithId, body: SpecialOfferBody, options?: OptionsType): ResponseType<null> => {
            return put<PathParamsWithId, undefined, SpecialOfferBody, null>({
                url: "/special-offer/:id",
                pathParams: pathParams,
                body: body,
                options: options,
            });
        },
        [put],
    );

    const deleteSpecialOffer = React.useCallback(
        (pathParams: PathParamsWithId, options?: OptionsType): ResponseType<null> => {
            return del<PathParamsWithId, undefined, null>({
                url: "/special-offer/:id",
                pathParams: pathParams,
                options: options,
            });
        },
        [del],
    );

    return {
        getAllSpecialOffer,
        getOneSpecialOffer,
        createSpecialOffer,
        updateSpecialOffer,
        deleteSpecialOffer,
    };
}

export default useSpecialOfferApi;
